import { render, staticRenderFns } from "./UploadHistory.vue?vue&type=template&id=39fe6887&scoped=true&"
import script from "./UploadHistory.vue?vue&type=script&lang=js&"
export * from "./UploadHistory.vue?vue&type=script&lang=js&"
import style0 from "./UploadHistory.vue?vue&type=style&index=0&id=39fe6887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe6887",
  null
  
)

export default component.exports